module.exports = __webpack_public_path__ + "static/media/story-17.589e31de.jpg";